import { secondaryThemeColors } from "./secondaryThemeColors";

const secondary = {
  colors: secondaryThemeColors,
};

export default secondary;
